import { render, staticRenderFns } from "./ProductTypeSimple.vue?vue&type=template&id=0f671e8c"
import script from "./ProductTypeSimple.vue?vue&type=script&lang=ts"
export * from "./ProductTypeSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports